import { render, staticRenderFns } from "./AnnotationAuditLogList.vue?vue&type=template&id=56d12090&scoped=true"
import script from "./AnnotationAuditLogList.vue?vue&type=script&lang=js"
export * from "./AnnotationAuditLogList.vue?vue&type=script&lang=js"
import style0 from "./AnnotationAuditLogList.vue?vue&type=style&index=0&id=56d12090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d12090",
  null
  
)

export default component.exports